// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1BBwK","title":"Images90_title__3q-Qa","images":"Images90_images__UO7IC"};